





import { Component, Vue, Prop } from "vue-property-decorator";
import { isObject, isArray } from "@szgc/plt-core-v2";
@Component({
  name: "LabelWidget",
  components: {}
})
export default class LabelWidget extends Vue {
  @Prop({
    required: true,
    type: Object
  })
  protected widget!: App.WebForm.LabelWidget;

  get labelStyle() {
    return {
      color: this.widget.color,
      borderRadius: this.widget.borderRadius + "px",
      backgroundColor: this.widget.backgroundColor,
      textAlign: this.widget.textAlign,
      fontSize: this.widget.fontSize + "px",
      fontWeight: this.widget.fontWeight,
      fontStyle: this.widget.fontStyle,
      height: this.widget.height + "px",
      lineHeight: this.widget.lineHeight + "px",
      paddingLeft: this.widget.paddingLeft + "px",
      paddingRight: this.widget.paddingRight + "px",
      marginTop: this.widget.marginTop + "px",
      marginBottom: this.widget.marginBottom + "px"
    };
  }

  get label() {
    if (this.widget.ext) {
      if (!this.widget.meta || this.widget.meta === "") {
        return this.widget.ext.value || "";
      } else {
        const ext = this.widget.ext;
        if (isObject(ext.object)) {
          return ext.object[this.widget.meta];
        } else if (isArray(ext.object)) {
          const obj = ext.object as Array<any>;
          const list = obj.map((d) => d[this.widget.meta]);
          return list.join(",");
        }
        return this.widget.name || "";
      }
    }
    return this.widget.name || "";
  }
}
